import { Button, Heading, Stack } from '@envoy/polarwind';
import React, { Component } from 'react';
import ChoiceColumnMapping from './ChoiceColumnMapping';

class ChoiceColumn extends Component {

  state = { choiceOptions: null };

  async componentDidMount() {
    const { column, api } = this.props;
    const choiceOptions = await api.getTableColumnChoiceOptions(column.tableName, column.value);
    this.setState({ choiceOptions });
  }

  onAddChoiceMapping = () => {
    const { choiceOptions: [firstOption] } = this.state;
    const { mapping, mappingIndex } = this.props;
    const { choiceMappings = [] } = mapping;

    this.props.onChangeFieldMapping({
        ...mapping,
        choiceMappings: (choiceMappings || []).concat({ envoyValue: '', serviceNowValue: firstOption.value }),
      },
      mappingIndex,
    );
  };

  get choiceColumnMappings() {
    const { column, mapping, mappingIndex, mapping: { choiceMappings = [] } } = this.props;
    return (choiceMappings || []).map(({ envoyValue, serviceNowValue }, index) => (
      <ChoiceColumnMapping
        key={index}
        index={index}
        column={column}
        mapping={mapping}
        envoyValue={envoyValue}
        serviceNowValue={serviceNowValue}
        mappingIndex={mappingIndex}
        choiceOptions={this.state.choiceOptions}
        onChangeFieldMapping={this.props.onChangeFieldMapping}
      />
    ));
  }

  render() {
    const { column } = this.props;
    const { choiceOptions } = this.state;
    return (
      <Stack vertical>
        <hr />
        <Heading element="h3" secondary>
          {column.label} Mappings
        </Heading>
        <Stack vertical>
          {this.choiceColumnMappings}
        </Stack>
        <Stack>
          <br />
          <Button
            disabled={!choiceOptions || !choiceOptions.length}
            onClick={this.onAddChoiceMapping}
            size="slim"
            outline
          >
            Add a choice mapping
          </Button>
        </Stack>
      </Stack>
    );
  }
}

export default ChoiceColumn;
